import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable()
export class ViewportService {
    width = typeof window !== 'undefined' ? window.innerWidth : 0;
    height = typeof window !== 'undefined' ? window.innerHeight : 0;
    viewType$: BehaviorSubject<string> = new BehaviorSubject('large');

    constructor() {
        if(typeof window !== 'undefined'){
            window.onresize = () => { this.setWindowSize(); }
        }
    }

    private setWindowSize(): void {
        this.width = window.innerWidth;
        this.height = window.innerHeight;
        this.setViewType();
    }

    private setViewType(): void {
        this.viewType$.next(this.width > 490 ? 'large' : 'medium')
    }
}
